import React, { PropsWithChildren } from 'react'
import { toast } from '@workwhile/ui'
import { createContext } from 'lib/createContext'
import { useRemoveExclusionMutation } from 'queries/wage/useRemoveExclusionMutation'

type RemoveExclusionFlowContextState = {
  actions: {
    remove: (placeGeoid: string) => void
  }
}

const [Context, useRemoveExclusionFlowContextValue] =
  createContext<RemoveExclusionFlowContextState>({
    name: 'RemoveExclusionFlowContext',
  })

export const RemoveExclusionFlowProvider = ({
  children,
  ruleId,
}: PropsWithChildren<{ ruleId: number }>) => {
  const { mutate: removeExclusion } = useRemoveExclusionMutation(ruleId)

  const value: RemoveExclusionFlowContextState = {
    actions: {
      remove: (placeGeoid: string) =>
        removeExclusion(
          { ruleId, placeGeoid },
          {
            onSuccess: () =>
              toast.success('Exclusion removed', { position: 'top-center' }),
          }
        ),
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useRemoveExclusionFlowContextValue }
